import { normalizeBrowserEventId } from "./event-id"

export type MetaPageViewLifecycle = {
  path: string
  eventId: string
  eventSourceUrl: string
  referrerUrl?: string
  claimed: boolean
}

export const resolveMetaPageViewLifecycle = ({
  current,
  path,
  eventSourceUrl,
  documentReferrer,
  createEventId,
}: {
  current?: MetaPageViewLifecycle
  path: string
  eventSourceUrl: string
  documentReferrer?: string
  createEventId: () => string
}): MetaPageViewLifecycle => {
  if (current?.path === path && normalizeBrowserEventId(current.eventId)) {
    return current
  }
  const eventId = normalizeBrowserEventId(createEventId())
  if (!eventId) throw new Error("Failed to create Meta PageView event ID")
  return {
    path,
    eventId,
    eventSourceUrl,
    referrerUrl: current?.eventSourceUrl || documentReferrer || undefined,
    claimed: false,
  }
}

export const claimMetaPageViewLifecycle = (
  lifecycle: MetaPageViewLifecycle
): boolean => {
  if (lifecycle.claimed) return false
  lifecycle.claimed = true
  return true
}
